import sharedMutations from "@/store/utils/shared-mutations";

const REMOVE_COACH_FROM_LIST = (state, id) => {
  const coach = state.coaches.find(coach => coach["id"] === id);
  state.coaches.splice(state.coaches.indexOf(coach), 1);
};

const CHANGE_POSITION_FROM_LIST = (state, params) => {
  const coach = state.coaches.find(coach => coach["key"] === params.id);
  coach.role = params.role;
  state.coaches.splice(state.coaches.indexOf(coach), 1, coach);
};

const CHANGE_COACH_ACTIVATION = (state, params) => {
  const coach = state.coaches.find(coach => coach["key"] === params.id);
  coach.isActive = params.isActive;
  coach.status = params.isActive ? "Active" : "Inactive";
  state.coaches.splice(state.coaches.indexOf(coach), 1, coach);
};

export default {
  ...sharedMutations,
  REMOVE_COACH_FROM_LIST,
  CHANGE_POSITION_FROM_LIST,
  CHANGE_COACH_ACTIVATION
};
